import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '../Box';
import { useMemo } from 'react';
import { getMediaQuery, getRetinaReadySrcSet } from './reponsive-image.utils';
import { useImageLoader } from '../Image';
export const ResponsiveImage = ({ sources, priority, unoptimized, css, ...props }) => {
    const imageLoader = useImageLoader();
    const greaterSource = useMemo(() => sources.sort((a, b) => b.width - a.width)[0], [sources]);
    return (_jsxs(Box, { as: "picture", css: css, children: [sources.map(({ src, width, height, quality, breakpoint }) => (_jsx("source", { width: width, height: height, media: getMediaQuery(sources, breakpoint), ...(unoptimized
                    ? {
                        src
                    }
                    : {
                        srcSet: getRetinaReadySrcSet({
                            quality: quality !== null && quality !== void 0 ? quality : 75,
                            imageLoader,
                            sources,
                            breakpoint,
                            priority,
                            width,
                            src
                        })
                    }) }, `${src}-${breakpoint}`))), _jsx("img", { ...props, width: greaterSource.width, height: greaterSource.height, src: unoptimized
                    ? greaterSource.src
                    : imageLoader({
                        src: greaterSource.src,
                        width: greaterSource.width,
                        quality: greaterSource.quality
                    }), ...(priority
                    ? { loading: 'eager', fetchPriority: 'high' }
                    : {
                        loading: 'lazy'
                    }) })] }));
};
